import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, canonical }) {
  let fullTitle = 'Lenea Evolinee';
  if (title && title !== 'Lenea Evolinee') {
    if (title.endsWith(' - Lenea Evolinee')) {
      fullTitle = title;
    } else {
      fullTitle = `${title} - Lenea Evolinee`;
    }
  }

  const defaultDesc = 'Professionel beskrivelse af Lenea Evolinees helhedsorienterede forløb med fokus på kropsterapi, Reiki Healing, astrologi og personlig udvikling for kvinder, der ønsker at finde hjem til sig selv.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDesc} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}
